<div class="edp-card-widget card">
    <div class="card-header">
        <ng-container *ngIf="!showCredit">
            <span class="card-title">{{ balanceValue | edpDotToComma  }}{{ 'pt.edp.edponline.chart.to.pay' | translate }}</span>
        </ng-container>
        <ng-container *ngIf="showCredit">
            <span class="card-title">{{ balanceValue | edpDotToComma  }}{{ 'pt.edp.edponline.chart.in.credit' | translate }}</span>

            <ng-container *ngTemplateOutlet="popoverTemplate"></ng-container>
        </ng-container>
        <span class="card-icon">
            <i class="icon-edponline-EDP_Online_payment"  aria-hidden="true"></i>
        </span>
    </div>
    <ng-container >
        <edp-chart class="card-body" [balance]="balanceObject" [chartId]="chartName" [fullCard]="false"></edp-chart>
    </ng-container>
</div>

<ng-template #popoverTemplate>
    <edp-popover #popComponent [popoverContent]="popoverContent"
        [popBtn]="'icon icon-edponline-Bop-025'">
        <ng-template #popoverContent>
            <span class="d-block tooltip-text">
                <span class="violet">{{ balanceObject.balance | edpDotToComma  }}{{ 'pt.edp.edponline.tooltip.value' | translate }}</span>{{ 'pt.edp.edponline.tooltip' | translate }}
            </span>
        </ng-template>
    </edp-popover>
</ng-template>